import type { SxProps, Theme } from '@mui/material';

export const EDUCATION_FORM_BOX_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  position: 'relative',
  textAlign: 'left',
};
